import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserWorkoutProgressMonths, getUserWorkoutProgressPeriod, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { CREATE_WORKOUT_PROGRESS, GET_WORKOUT_PROGRESS_MONTHS, GET_WORKOUT_PROGRESS_PERIOD } from '../new';

import { useEffectOnSuccess } from '.';

const useUserWorkoutProgress = () => {
  const dispatch = useDispatch();
  const monthsWorkouts = useSelector(state => state.workoutProgress.getMonths);
  const periodWorkouts = useSelector(state => state.workoutProgress.getPeriod);

  useEffect(() => {
    if (monthsWorkouts.status === StateStatus.NOT_INITIALIZED || periodWorkouts.status === StateStatus.NOT_INITIALIZED) {
      dispatch(getUserWorkoutProgressPeriod(7));
      dispatch(getUserWorkoutProgressMonths());
    }
  }, [dispatch, monthsWorkouts.status, periodWorkouts.status]);

  useEffectOnSuccess(
    state => state.workoutProgress.create,
    () => {
      dispatch(resetState(CREATE_WORKOUT_PROGRESS));
      dispatch(resetState(GET_WORKOUT_PROGRESS_PERIOD));
      dispatch(resetState(GET_WORKOUT_PROGRESS_MONTHS));
    }
  );

  return { months: { ...monthsWorkouts }, period: { ...periodWorkouts } };
};

export default useUserWorkoutProgress;
